<div>
  <cc-sketch-pad-image [model]="field"></cc-sketch-pad-image>
</div>
